"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _UnknownTooltip = _interopRequireDefault(require("./UnknownTooltip"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function OwnedLicenseCreate(row) {
  var sourceEntity = row.sourceEntity,
    sourceType = row.sourceType,
    targetEntity = row.targetEntity;
  if (sourceEntity && targetEntity) {
    switch (sourceType) {
      case 'Cccisd\\Licensing\\Models\\HeldLicense':
        return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("b", null, targetEntity), " started a new license using an available license from\xA0", sourceEntity);
      case 'Cccisd\\Licensing\\Models\\Voucher':
        return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("b", null, targetEntity), " started a new license using voucher code\xA0", /*#__PURE__*/_react["default"].createElement("b", null, sourceEntity));
      default:
        return /*#__PURE__*/_react["default"].createElement("span", null, targetEntity, " started a new license");
    }
  }
  if (targetEntity) {
    switch (sourceType) {
      case 'Cccisd\\Licensing\\Models\\HeldLicense':
        return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("b", null, targetEntity), " started a new license using an available license from unknown group");
      case 'Cccisd\\Licensing\\Models\\Voucher':
        return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("b", null, targetEntity), " started a new license using a voucher that has since been deleted");
      case null:
        return /*#__PURE__*/_react["default"].createElement("span", null, "Admin created new license for ", /*#__PURE__*/_react["default"].createElement("b", null, targetEntity));
      default:
        return /*#__PURE__*/_react["default"].createElement("span", null, targetEntity, " started a new license");
    }
  }
  if (sourceEntity) {
    switch (sourceType) {
      case 'Cccisd\\Licensing\\Models\\HeldLicense':
        return /*#__PURE__*/_react["default"].createElement("span", null, "Unknown user started a new license using an available license from\xA0", sourceEntity, /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], null));
      case 'Cccisd\\Licensing\\Models\\Voucher':
        return /*#__PURE__*/_react["default"].createElement("span", null, "Unknown user started a new license using voucher code\xA0", /*#__PURE__*/_react["default"].createElement("b", null, sourceEntity), /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], null));
      default:
        return /*#__PURE__*/_react["default"].createElement("span", null, "Unknown user started a new license", /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], null));
    }
  }
  if (sourceType) {
    return /*#__PURE__*/_react["default"].createElement("span", null, "An unknown user started a license", /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], null));
  }
  return /*#__PURE__*/_react["default"].createElement("span", null, "Admin created new license for an unknown user", /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], null));
}
var _default = exports["default"] = OwnedLicenseCreate;